import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Chip,
  TablePagination,
  Pagination,
} from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import { useLazyQuery } from "@apollo/client";
import {
  GET_DELIVERIES,
  GET_EXAM_SCHEDULE_ID,
} from "utils/graphql/services/exam-schedule/queries";
import myClassroomClient from "utils/graphql/myclassroom";
import { Link, useRouteMatch } from "react-router-dom";
import ContentRight from "shared/molecules/content-right";
import { makeStyles } from "@mui/styles";
import { indigo } from "@mui/material/colors";
import SchDeliveryTable from "../table/delivery-page";
import Loader from "pages/build-test/loader";
import { isEmpty } from "utils/helpers";
import NoDataFound from "shared/molecules/no-data";
import { DeliveryFilter } from "./filter";
import { getCollegeFromStateIdForUp } from "utils/metadata-split/depedentApiFetch";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import { filterByIds } from "./helper";

const useStyles: any = makeStyles((indigoTheme) => ({
  label: {
    textDecoration: "none",
    textAlign: "center",
    color: indigo[700],
    marginLeft: "80%",
  },
  Btn: {
    backgroundColor: "#3f50b5",
    color: "white",
    width: "90px",
  },
  BtnWrapper: {
    display: "flex",
    gap: "20px",
    justifyContent: "flex-end",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
}));

type SearchState = {
  branch_ids: string[];
  class_ids: string;
};

const SchDelivery = () => {
  const classes = useStyles();
  // Sample data from the provided JSON
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [searchPayload, setSearchPayload] = useState<SearchState>({branch_ids:[],class_ids:""});
  const [stateIds, setStateIds] = useState([]);
  const [collegeIds, setcollegeIds] = useState([]);
  const [classIds, setClassIds] = useState([]);
  const match: any = useRouteMatch();
  const [page, setPage] = useState(1);
  const dispatch = useAppDispatch();

  const { isLoading, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );

  const [getScheduleDeliverys, { loading: loading, error: error, data: data }] =
    useLazyQuery(GET_DELIVERIES, {
      client: myClassroomClient,
    });

  const [getExamById, { loading: loadingUp, error: errorUp, data: dataSch }] =
    useLazyQuery(GET_EXAM_SCHEDULE_ID, {
      client: myClassroomClient,
    });

  const deliveries = data?.getDeliveriesByScheduleExamDeliveryId?.deliveries;
  const paginationInfo = data?.getDeliveriesByScheduleExamDeliveryId;
  const hasNextPage = deliveries?.length === entriesPerPage;

  const updateMetaData = (listData, metaKey, listData2, metaKey2) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    metadataList[metaKey2] = listData2;
    dispatch(metadataSuccess(metadataList));
  };

  useEffect(() => {
    getScheduleDeliverys({
      variables: {
        scheduleExamDeliveryId: match?.params?.schdule_id,
        page,
        limit: entriesPerPage,
        classIds: searchPayload?.class_ids ? [searchPayload?.class_ids] : [],
        collegeIds: searchPayload?.branch_ids,
      },
    });
  }, [page, entriesPerPage,searchPayload]);

  useEffect(() => {
    getExamById({
      variables: {
        id: match?.params?.schdule_id,
      },
    });
  }, []);

  useEffect(() => {
    if (stateIds?.length > 0) {
      (async () => {
        const call1 = await getCollegeFromStateIdForUp(stateIds, "");
        updateMetaData(
          filterByIds(call1[0], collegeIds, "college_id"),
          "college_list_del_sch",
          filterByIds(metaData.class_course_batch_data, classIds, "class_id"),
          "class_list_del_sch"
        );
      })();
    }
  }, [stateIds]);

  useEffect(() => {
    if (!isEmpty(dataSch)) {
      const { class_ids, state_ids, college_ids } = dataSch?.getExamSchedule;
      setStateIds(state_ids);
      setcollegeIds(college_ids);
      setClassIds(class_ids);
    }
  }, [dataSch]);

  return (
    <Box sx={{ p: "10px", maxWidth: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          {dataSch?.getExamSchedule?.scheduled_exam_name || "-"}
        </Typography>
        <ContentRight>
          <Link
            to={`/exam_schedule/delivery/create/${match?.params?.schdule_id}`}
            className={classes.label}
          >
            <Button variant="contained">Create Delivery </Button>
          </Link>
        </ContentRight>
      </Box>
      <Paper sx={{ p: "10px" }}>
        {/* Filters Section */}
        <DeliveryFilter setSearchPayload={setSearchPayload} setPage={setPage} />
        <Paper sx={{ p: 1, mb: 3, marginTop: "10px" }}>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="body2">Show</Typography>
              <FormControl sx={{ minWidth: 80 }}>
                <Select
                  value={entriesPerPage}
                  onChange={(e: any) => setEntriesPerPage(e.target.value)}
                  size="small"
                >
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
              <Typography variant="body2">Entries</Typography>
            </Box>
          </Box>
        </Paper>

        {/* Table Section */}
        {loading && <Loader />}
        {!loading && !isEmpty(deliveries) ? (
          <SchDeliveryTable
            deliveries={deliveries}
            limit={entriesPerPage}
            setLimit={setEntriesPerPage}
            setPage={setPage}
            page={page}
            schdID={match?.params?.schdule_id}
          />
        ) : (
          <>{!loading && <NoDataFound message="No Data" />}</>
        )}

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 2,
          }}
        >
          <Pagination
            count={hasNextPage ? page + 1 : page} // Show one more page if there might be more data
            page={page}
            onChange={(event, value) => setPage(value)}
            color="primary"
            showFirstButton={page > 1}
            showLastButton={false} // Don't show last button since we don't know total pages
            hidePrevButton={page === 1}
            hideNextButton={!hasNextPage}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default SchDelivery;
